module.exports = __webpack_public_path__ + "media/images/meeting/ic_time-eb610226820491f4d92e5555057eaa56.svg";